import "@/store"

export const state = () => ({
  results: [],
  items_count: 0,
  loading: false
})

export const mutations = {
  setList(state, payload) {
    state.list = payload || []
  },

  setState(state, payload) {
    Object.keys(state).forEach((item) => {
      state[item] = payload[item]
    })
  },

  createItem(state, payload) {
    state.list = [...state.list, payload]
  },

  updateItem(state, payload) {
    if (state.list) {
      const f = state.list.findIndex((item) => item.id == payload.id)

      if (f != -1) {
        state.list = [
          ...state.list.slice(0, f),
          payload,
          ...state.list.slice(f + 1)
        ]
      }
    }
  },

  deleteItem(state, payload) {
    const f = state.list.findIndex((item) => item.id == payload)

    if (f != -1) {
      state.list = [...state.list.slice(0, f), ...state.list.slice(f + 1)]
    }
  }
}

export const actions = {
  fetch({ commit }, params) {
    commit("setState", { loading: true })

    return this.$api
      .get("/banners/list", params)
      .then((res) => {
        if (res && res.data) {
          commit("setState", {
            results: (res.data && res.data.results) || [],
            items_count: (res.data && res.data.items_count) || 0,
            loading: false
          })
          return res
        }
      })
      .catch((err) => {
        console.error(err)
        commit("setState", { loading: false })
      })
  },

  detail(_, bannerId) {
    return this.$api
      .get("/banners/get/" + bannerId)
      .then((res) => {
        if (res && res.data) {
          return res.data || {}
        }
      })
      .catch((err) => console.log(err))
  },

  submit(_, payload) {
    const f = new FormData(),
      newForm = { ...payload, link: JSON.stringify(payload.link) }

    Object.keys(newForm).forEach((item) => f.append(item, newForm[item]))

    const req = {
      url: !payload.id ? "create" : "update/" + payload.id,
      method: !payload.id ? "post" : "put",
      data: f
    }

    return this.$api[req.method](`/banners/${req.url}`, req.data)
      .then((res) => {
        // commit("createItem", res.data);
        return res
      })
      .catch((err) => {
        console.log(err)
      })
  },

  delete(_, bannerId) {
    return this.$api
      .delete("/banners/delete/" + bannerId)
      .then((res) => res && res.status >= 200 && res.status <= 204)
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}
